module.exports = __webpack_public_path__ + "static/shopify_oauth_consent_screen2-fdd61bc9cc8a8d2fa201eacac78cdbb3.png";